import api from "../api";

export const getEmailLogs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/email-logs", { params });
};

export const getEmailLog = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/email-logs/${id}`);
};

export const getEmailLogStats = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/email-logs/stats", { params });
};

export const resendEmail = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `admin/email-logs/${id}/resend`);
};

export const getUserEmailLogs = async (userId, params = {}) => {
  return api.getApi().get(api.getBaseUrl() + `admin/users/${userId}/email-logs`, { params });
};

